import { useSyncExternalStore } from 'react';

let waking = false;
const listeners = new Set<() => void>();

/**
 * Marks whether the API is currently waking (a 503 with `Retry-After` was seen and no
 * successful answer since). The API client calls it; the banners read it. Platform-neutral: the
 * school app draws `WakingBanner`, the Expo app its own bar.
 *
 * @param {boolean} value -- The new state.
 */
export const setWaking = (value: boolean): void => {
  if (waking === value) return;
  waking = value;
  for (const listener of listeners) listener();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * Whether the API is waking right now.
 *
 * @returns The state.
 */
export const useWaking = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => waking,
    () => false,
  );
